import React, { useState } from 'react';
import { useFormatter } from '../../../core/formatter/use-formatter';
import { Dialog } from '../../../visual-components/dialog/dialog';
import { Typography } from '../../../visual-components/typography/typography';
import { LinkButton } from '../../../visual-components/link/link';
import { ArticleSearch } from '../../backend/openapi/api-types';
import styles from './table-cell-weight-dialog.module.scss';
import { CartSection } from './cart-section';

type Props = {
  weight: number;
  unit?: string;
  titleDialog: string;
  article: ArticleSearch;
  readOnly: boolean;
};

// TODO: @Simon Trigger is set up entirely wrong
export const TableCellWeightDialog: React.FC<Props> = ({ titleDialog, unit, weight, article, readOnly }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { formatInteger } = useFormatter();

  const handleClose = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  const onOpenChange = (open: boolean) => {
    if (readOnly) {
      return;
    }
    setIsDialogOpen(open);
  };

  return (
    <div className={styles.root}>
      <Dialog
        isOpen={isDialogOpen}
        title={titleDialog}
        trigger={
          <div className={styles.weightContainer}>
            <Typography variant="maintext">{formatInteger(weight)}</Typography>
            <Typography color="anthrazit-75" variant="maintext">
              {unit}
            </Typography>
            {readOnly ? (
              <span className={styles.weightContainerButton} />
            ) : (
              <LinkButton aria-label={titleDialog} className={styles.weightContainerButton} icon="pen-box" />
            )}
          </div>
        }
        onOpenChange={onOpenChange}
      >
        <CartSection article={article} state="dialog" onClose={handleClose} />
      </Dialog>
    </div>
  );
};
